import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { FlashMessagesService } from 'angular2-flash-messages'

import { environment } from '../../../../environments/environment'
import { appConstants } from '../../../app.constants'
import { Role } from '../../../common/enums/role.enum'
import { Company } from '../../../common/interfaces/company.interface'
import { BreadcrumbService } from '../../../common/services/breadcrumb.service'
import { ResourceService } from '../../../common/services/resource.service'

@Component({
  selector: 'app-company-create-edit',
  templateUrl: './company-create-edit.component.html',
  styleUrls: ['./company-create-edit.component.scss'],
  providers: [ResourceService]
})
export class CompanyCreateEditComponent implements OnInit {
  company: Company
  companyToDelete: Company
  mode: string
  loading: boolean
  submitLoading: boolean

  form: FormGroup = this.formBuilder.group({
    name: ['', Validators.required]
  })
  constructor(
    private resourceService: ResourceService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private flashMessagesService: FlashMessagesService,
    private breadcrumbService: BreadcrumbService
  ) {}

  ngOnInit() {
    this.mode = this.activatedRoute.snapshot.data.mode
    if (this.mode === 'create') {
      this.breadcrumbService.breadcrumbLinks.next([
        {
          path: '/companies',
          label: "Bureaux d'études"
        },
        {
          label: "Nouveau Bureau d'études"
        }
      ])
    } else {
      this.loading = true
      this.resourceService
        .show('companies', this.activatedRoute.snapshot.params.id)
        .subscribe(
          (companyRes: Company) => {
            this.loading = false
            this.company = companyRes

            this.form.controls.name.setValue(companyRes.name)

            // Set breadcrumbs
            this.breadcrumbService.breadcrumbLinks.next([
              {
                path: '/companies',
                label: 'Utilisateurs'
              },
              {
                label: this.company.name
              }
            ])
          },
          error => {
            this.loading = false
            this.flashMessagesService.show(
              'Une erreur a eu lieu : Impossible de récupérer le(s) élémént(s) désiré(s).',
              {
                cssClass: 'notification is-danger',
                timeout: appConstants.FLASH_MESSAGE_TIMEOUT
              }
            )
          }
        )
    }
  }

  submit(form: FormGroup) {
    const formData = new FormData()
    formData.append('name', form.value.name)
    this.submitLoading = true
    if (this.mode === 'create') {
      this.resourceService.store('companies', formData).subscribe(
        res => {
          this.submitLoading = false
          this.flashMessagesService.show(`Le bureau d'études a bien été créé`, {
            cssClass: 'notification is-success',
            timeout: appConstants.FLASH_MESSAGE_TIMEOUT
          })
          this.router.navigate(['/companies'])
        },
        err => {
          this.submitLoading = false
          this.flashMessagesService.show(
            'Error ' +
              JSON.stringify(err.error.message.map(m => m.constraints)),
            {
              cssClass: 'notification is-danger',
              timeout: appConstants.FLASH_MESSAGE_TIMEOUT
            }
          )
        }
      )
    } else {
      // Update existing resource
      this.resourceService.update('companies', this.company.id, formData).subscribe(
        res => {
          this.submitLoading = false
          this.flashMessagesService.show(
            `Le bureau d'études a bien été mis à jour`,
            {
              cssClass: 'notification is-success',
              timeout: appConstants.FLASH_MESSAGE_TIMEOUT
            }
          )
          this.router.navigate(['/companies'])
        },
        err => {
          this.submitLoading = false
          this.flashMessagesService.show(
            'Error ' +
              JSON.stringify(err.error.message.map(m => m.constraints)),
            {
              cssClass: 'notification is-danger',
              timeout: appConstants.FLASH_MESSAGE_TIMEOUT
            }
          )
        }
      )
    }
  }

  delete(company: Company) {
    this.companyToDelete = company
  }
  onDeleteCanceled() {
    delete this.companyToDelete
  }
}
